import {ssr_window} from "../../helpers/ssr";
const MOBILE_TEXT = 'mobile'
const TABLET_TEXT = 'tablet'
const LAPTOP_TEXT = 'laptop'
const DESKTOP_TEXT = 'desktop'

export default {
  actions: {
    actionResolution: (context, val) => context.commit('mutationSetResolution', val),
  },
  mutations: {
    mutationSetResolution: (state, val) => state.resolution = val,
  },
  state: {
    resolution: ssr_window.innerWidth || 1024,
    breakpoints: {
      576: MOBILE_TEXT,
      1024: TABLET_TEXT,
      1440: LAPTOP_TEXT,
    }
  },
  getters: {
    getResolution: state => state.resolution,
    getCurrentDevice: state => {
      for (let breakpoint of Object.keys(state.breakpoints)) {
        if (state.resolution <= breakpoint) {
          return state.breakpoints[breakpoint]
        }
      }
      return DESKTOP_TEXT
    },
    getIsMobile: (state, getters) => {
      return getters.getCurrentDevice === MOBILE_TEXT
    },
    getIsTablet: (state, getters) => {
      return getters.getCurrentDevice === TABLET_TEXT
    },
    getIsTabletOrMobile: (state, getters) => {
      return getters.getIsMobile || getters.getIsTablet
    },
  }
}
